<template>
    <div class="quick-search-panel">
        <template v-if="!isMobile">
            <div class="row title-con">
                <h4 class="title">{{ 'Quick Search' | translate }}</h4>
                 <router-link v-if="hasMoreOptions" class="more-options" :to="{ name: 'user-search-profiles' }">
                    <span>{{ 'More Options' | translate }}</span>
                </router-link>
            </div>
            <div class="row form-list">
                <div class="form-group col-md-2">
                    <label>{{ 'I am a' | translate }}</label>
                    <div class="select-wrapper">
                        <select class="form-control" v-model="sex">
                            <option :value="sex">{{ sex_label }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group col-md-2">
                    <label>{{ 'Looking for' | translate }}</label>
                    <div class="select-wrapper">
                        <select class="form-control" v-model="seeking">
                            <option disabled :value="null">{{ 'Select from list' | translate }}</option>
                            <option v-for="val in seeking_options" :disabled="disableGenderOptions(val.value)" :value="val.value">{{ val.label }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group col-md-2">
                    <label>{{ 'Age' | translate }}</label>
                    <div class="select-wrapper">
                        <select class="form-control" v-model="age">
                            <option :value="null">{{ 'All age groups' | translate }}</option>
                            <option v-for="val in ages" :value="val.value">{{ val.label }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group col-md-3">
                    <template v-if="nearby_distances && nearby_distances.length">
                        <label>{{ 'Distance' | translate }}</label>
                        <div class="select-wrapper">
                            <select class="form-control" v-model="nearby_distance">
                                <option v-for="val in nearby_distances" :value="val.id">{{ val.name }}</option>
                            </select>
                        </div>
                    </template>
                    <template v-else-if="provinces && provinces.length">
                        <label>{{ 'Location' | translate }}</label>
                        <div class="select-wrapper">
                            <select class="form-control" v-model="province_id">
                                <option v-for="val in provinces" :value="val.id">{{ val.name }}</option>
                            </select>
                        </div>
                    </template>
                </div>
                <div class="form-group col-md-3">
                    <label>&nbsp;</label>
                    <div class="input-wrapper">
                        <button class="btn btn-search" @click="search()">
                            <span>{{ 'Search for' | translate }}</span>
                            <i class="icon icon-search"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="row check-box-con">
                <div class="form-group col-xs-12">
                    <label :class="`label-checkbox norm ${!profile_picture ? '': 'active'}`">
                        <input type="checkbox" class="checkbox" v-model="profile_picture">
                    </label>
                    <label class="checkbox-text">{{ 'Only profiles with photo' | translate }}</label>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="mobile-layout">
                <div class="wrapper row">
                    <div class="col-xs-6">
                        <div class="box seeking">
                            <span v-for="val in seeking_options" :key="val.value" :class="`options ${disableGenderOptions(val.value) ? 'disabled': (seeking == val.value ? 'active' : '') }`"
                             @click="customOptionClick('seeking', val.value)">
                                {{ val.label | normalize }}
                            </span>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="box form-group">
                            <h3>{{ 'WITH PICTURE' | translate | normalize }}</h3>
                            <div class="custom-ios-checkbox">
                                <input class="custom-checkbox-input" name="profile_pic" type="checkbox" id="profile_pic" v-model="profile_picture">
                                <label class="custom-checkbox" for="profile_pic">
                                    <span class="aux"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="box form-group">
                            <h3>{{ 'Age' | translate | normalize }}</h3>
                            <div class="select-wrapper">
                                <select class="form-control" v-model="age">
                                    <option :value="null">{{ 'all age groups' | translate | normalize }}</option>
                                    <option v-for="val in ages" :key="val.value" :value="val.value">{{ val.label | normalize }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <template v-if="nearby_distances && nearby_distances.length">
                            <div class="box form-group">
                                <h3>{{ 'Distance' | translate | normalize }}</h3>
                                <div class="select-wrapper">
                                    <select class="form-control" v-model="nearby_distance">
                                        <option v-for="val in nearby_distances" :key="val.id" :value="val.id">{{ val.name | normalize }}</option>
                                    </select>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="provinces && provinces.length">
                            <div class="box form-group">
                                <h3>{{ 'Location' | translate | normalize }}</h3>
                                <div class="select-wrapper">
                                    <select class="form-control" v-model="province_id">
                                        <option v-for="val in provinces" :key="val.id" :value="val.id">{{ val.name | normalize }}</option>
                                    </select>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="full-title-con" @click="search()">
                    <h3>{{ 'Quick Search' | translate | normalize }}</h3>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import QuickSearch from '@views/user/partials/QuickSearchPanel/quick_search'

    export default {
        name: 'quick-search-panel',
        mixins: [QuickSearch]
    }
</script>

<style lang="scss" src="./quick_search.scss"></style>
